import React from "react";
import styles from './divider.module.scss';
import { shapes } from './shapes';
export default function Divider(props) {
    var _a, _b, _c, _d;
    let className;
    const generateSvg = (props, shapes) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const template = shapes.find((shape) => {
            var _a;
            return shape.label[0].toLowerCase() === ((_a = props === null || props === void 0 ? void 0 : props.style) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        });
        if (template) {
            className = props.style.toLowerCase();
        }
        else {
            if (!props.style) {
                return {
                    borderTop: `${(_a = props === null || props === void 0 ? void 0 : props.weight) === null || _a === void 0 ? void 0 : _a.size}${(_b = props === null || props === void 0 ? void 0 : props.weight) === null || _b === void 0 ? void 0 : _b.unit} solid ${props === null || props === void 0 ? void 0 : props.color}`,
                    width: `${(_c = props === null || props === void 0 ? void 0 : props.width) === null || _c === void 0 ? void 0 : _c.size}${(_d = props === null || props === void 0 ? void 0 : props.width) === null || _d === void 0 ? void 0 : _d.unit}`,
                };
            }
            else {
                return {
                    borderTop: `${(_e = props === null || props === void 0 ? void 0 : props.weight) === null || _e === void 0 ? void 0 : _e.size}${(_f = props === null || props === void 0 ? void 0 : props.weight) === null || _f === void 0 ? void 0 : _f.unit} ${props === null || props === void 0 ? void 0 : props.style} ${props === null || props === void 0 ? void 0 : props.color}`,
                    width: `${(_g = props === null || props === void 0 ? void 0 : props.width) === null || _g === void 0 ? void 0 : _g.size}${(_h = props === null || props === void 0 ? void 0 : props.width) === null || _h === void 0 ? void 0 : _h.unit}`,
                };
            }
        }
    };
    const style = generateSvg(props, shapes);
    const containerStyles = {
        paddingTop: `${(_a = props === null || props === void 0 ? void 0 : props.gap) === null || _a === void 0 ? void 0 : _a.size}${(_b = props === null || props === void 0 ? void 0 : props.gap) === null || _b === void 0 ? void 0 : _b.unit}`,
        paddingBottom: `${(_c = props === null || props === void 0 ? void 0 : props.gap) === null || _c === void 0 ? void 0 : _c.size}${(_d = props === null || props === void 0 ? void 0 : props.gap) === null || _d === void 0 ? void 0 : _d.unit}`,
    };
    return (React.createElement("div", { className: 'elementor-widget-divider', style: containerStyles },
        React.createElement("div", { className: `${styles['divider-elementor-divider-seperator']} ${className}`, style: style })));
}
